
type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_PREFIX = '[NODE]';

const getLogStyle = (level: LogLevel): string => {
  switch (level) {
    case 'debug':
      return 'color: #808080';
    case 'info':
      return 'color: #0066cc';
    case 'warn':
      return 'color: #ff9900';
    case 'error':
      return 'color: #cc0000';
  }
};

// Simplified stack trace helper
const getCallerInfo = (): string => {
  try {
    const err = new Error();
    const stack = err.stack?.split('\n')[3] || '';
    const match = stack.match(/at (.+) \(/);
    return match ? ` [${match[1]}]` : '';
  } catch (e) {
    return '';
  }
};

export const logger = {
  debug: (message: string, ...args: any[]) => {
    console.debug(`%c${LOG_PREFIX}${getCallerInfo()} ${message}`, getLogStyle('debug'), ...args);
  },
  
  info: (message: string, ...args: any[]) => {
    console.info(`%c${LOG_PREFIX}${getCallerInfo()} ${message}`, getLogStyle('info'), ...args);
  },
  
  warn: (message: string, ...args: any[]) => {
    console.warn(`%c${LOG_PREFIX}${getCallerInfo()} ${message}`, getLogStyle('warn'), ...args);
  },
  
  error: (message: string, ...args: any[]) => {
    console.error(`%c${LOG_PREFIX}${getCallerInfo()} ${message}`, getLogStyle('error'), ...args);
  }
};
